import { WebSocketEventMessages } from 'src/features/visitor/types';

export const NEW_STAY_AND_PASS_EVENTS = [
    WebSocketEventMessages.NEW_LPR_DETECTION,
    WebSocketEventMessages.NEW_ACTIVE_STAY,
    WebSocketEventMessages.NEW_ACTIVE_STAY_LOG_EVENT,
    WebSocketEventMessages.NEW_ACTIVE_STAY_PERIOD,
    WebSocketEventMessages.NEW_ACTIVE_STAY_PERIOD_LOG_EVENT,
    WebSocketEventMessages.COMPLETED_ACTIVE_STAY,
    WebSocketEventMessages.COMPLETED_ACTIVE_STAY_LOG_EVENT,
    WebSocketEventMessages.COMPLETED_ACTIVE_STAY_PERIOD,
    WebSocketEventMessages.COMPLETED_ACTIVE_STAY_PERIOD_LOG_EVENT,
    WebSocketEventMessages.NEW_ENTRY_PASS,
    WebSocketEventMessages.NEW_EXIT_PASS,
];

export const GATEWAY_PASS_ONLY_EVENTS = [WebSocketEventMessages.NEW_ENTRY_PASS, WebSocketEventMessages.NEW_EXIT_PASS];
